import {geoCodeByAddress, storeGeoCodeByAddress} from "../service";

export const geoCodeAddress = (address: string): Promise<number[]> => {
	return (
		geoCodeByAddress(address)
			.then( (data: { list: { lat: number; lng: number }}) => {
				if( !data ) return [];
				if( !data.list ) return [];
				return ([data.list.lat, data.list.lng])
				return [];
			})
	);
};

export const setGeoCodeAddress = (address, lat, lng) => storeGeoCodeByAddress({address: address, lat: lat, lng: lng});

